import { CSSTransition } from 'react-transition-group';
import { IconRegenerateOutlined } from 'components/common/SVGIcons';
import { ButtonSecondaryOutlinedBlue } from 'components/common/buttonsComponents';
import { timers, Root, Text } from './Footer.styles';

export default function Footer({ show = false, onRegenerateClick }) {
  return (
    <CSSTransition in={show} timeout={timers.transitionDuration} unmountOnExit>
      <Root>
        <Text>Regenerate response to update a troubleshooting instruction</Text>
        <ButtonSecondaryOutlinedBlue onClick={onRegenerateClick}>
          <IconRegenerateOutlined width={11} height={11} />
          Regenerate Response
        </ButtonSecondaryOutlinedBlue>
      </Root>
    </CSSTransition>
  );
}
